import { render, staticRenderFns } from "./InboxSidebar.vue?vue&type=template&id=5d7ab8ff&scoped=true"
import script from "./InboxSidebar.vue?vue&type=script&lang=js"
export * from "./InboxSidebar.vue?vue&type=script&lang=js"
import style0 from "./InboxSidebar.vue?vue&type=style&index=0&id=5d7ab8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ab8ff",
  null
  
)

export default component.exports